import { officeConstants } from '../actions/constants';

const initialState = {
    office: null,
    hasOfficeAccess: false,
    offices: [],
    products: [],
    officeLoading: false,
    officeError: null,
    modelsData: {},
    modelLoadingProgress: {},
    modelError: null,
};

export default (state = initialState, action) => {
    switch (action.type) {
        case officeConstants.CHECK_OFFICE_ACCESS_REQUEST:
            return {
                ...state,
                officeLoading: true,
                officeError: null,
            };

        case officeConstants.CHECK_OFFICE_ACCESS_SUCCESS:
            return {
                ...state,
                officeLoading: false,
                hasOfficeAccess: action.payload.hasAccess,
                office: action.payload.office,
            };

        case officeConstants.CHECK_OFFICE_ACCESS_FAILURE:
            return {
                ...state,
                officeLoading: false,
                officeError: action.payload.error,
                hasOfficeAccess: false,
                office: null,
            };

        case officeConstants.GET_OFFICES_REQUEST:
            return {
                ...state,
                officeLoading: true,
                officeError: null,
            };

        case officeConstants.GET_OFFICES_SUCCESS:
            return {
                ...state,
                officeLoading: false,
                offices: action.payload.offices,
            };

        case officeConstants.GET_OFFICES_FAILURE:
            return {
                ...state,
                officeLoading: false,
                officeError: action.payload.error,
            };

        case officeConstants.CREATE_OFFICE_REQUEST:
            return {
                ...state,
                officeLoading: true,
                officeError: null,
            };

        case officeConstants.CREATE_OFFICE_SUCCESS:
            return {
                ...state,
                officeLoading: false,
                offices: [...state.offices, action.payload.office],
            };

        case officeConstants.CREATE_OFFICE_FAILURE:
            return {
                ...state,
                officeLoading: false,
                officeError: action.payload.error,
            };

        case officeConstants.UPDATE_OFFICE_REQUEST:
            return {
                ...state,
                officeLoading: true,
                officeError: null,
            };

        case officeConstants.UPDATE_OFFICE_SUCCESS:
            return {
                ...state,
                officeLoading: false,
                offices: state.offices.map((office) =>
                    office._id === action.payload.office._id ? action.payload.office : office
                ),
            };

        case officeConstants.UPDATE_OFFICE_FAILURE:
            return {
                ...state,
                officeLoading: false,
                officeError: action.payload.error,
            };

        case officeConstants.UPDATE_OFFICE_USERS_REQUEST:
            return {
                ...state,
                officeLoading: true,
                officeError: null,
            };

        case officeConstants.UPDATE_OFFICE_USERS_SUCCESS:
            return {
                ...state,
                officeLoading: false,
                offices: state.offices.map((office) =>
                    office._id === action.payload.office._id ? action.payload.office : office
                ),
            };

        case officeConstants.UPDATE_OFFICE_USERS_FAILURE:
            return {
                ...state,
                officeLoading: false,
                officeError: action.payload.error,
            };

        case officeConstants.GET_OFFICE_PRODUCTS_REQUEST:
            return {
                ...state,
                officeLoading: true,
                officeError: null,
            };

        case officeConstants.GET_OFFICE_PRODUCTS_SUCCESS:
            return {
                ...state,
                officeLoading: false,
                products: action.payload.products,
            };

        case officeConstants.GET_OFFICE_PRODUCTS_FAILURE:
            return {
                ...state,
                officeLoading: false,
                officeError: action.payload.error,
            };

        case officeConstants.GET_PRODUCT_MODEL_DATA_REQUEST:
            return {
                ...state,
                modelError: null,
            };

        case officeConstants.GET_PRODUCT_MODEL_DATA_PROGRESS:
            return {
                ...state,
                modelLoadingProgress: {
                    ...state.modelLoadingProgress,
                    [action.payload.productId]: action.payload,
                },
            };

        case officeConstants.GET_PRODUCT_MODEL_DATA_SUCCESS:
            return {
                ...state,
                modelsData: {
                    ...state.modelsData,
                    [action.payload.productId]: action.payload,
                },
                modelError: null,
            };

        case officeConstants.GET_PRODUCT_MODEL_DATA_FAILURE:
            return {
                ...state,
                modelError: action.payload.error,
            };

        case officeConstants.CLEAR_PRODUCT_MODEL_MODEL_PROGRESS: {
            const nextProgress = { ...state.modelLoadingProgress };

            delete nextProgress[action.payload.productId];

            return {
                ...state,
                modelLoadingProgress: nextProgress,
            };
        }

        default:
            return state;
    }
};